(function () {
  var roots = document.querySelectorAll('.ssh');
  if (!roots.length) return;
  roots.forEach(function (r) { r.classList.add('is-js'); });
  var root = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = function (cents) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); };

  /* ---- reveal on scroll ---- */
  var revs = root.querySelectorAll('.ssh-reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    revs.forEach(function (el) { io.observe(el); });
  } else { revs.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---- chapter rail ---- */
  var nav = document.getElementById('ssh-chapnav');
  var links = nav ? nav.querySelectorAll('a') : [];
  var chaps = ['ssh-ch1', 'ssh-ch2', 'ssh-ch3', 'ssh-ch4'].map(function (id) { return document.getElementById(id); });
  if ('IntersectionObserver' in window && nav) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-ch') === e.target.id); }); } });
    }, { rootMargin: '-45% 0px -50% 0px' });
    chaps.forEach(function (c) { if (c) cio.observe(c); });
    var story = document.querySelector('.ssh-story');
    if (story) { var sio = new IntersectionObserver(function (es) { nav.classList.toggle('is-on', es[0].isIntersecting); }, { rootMargin: '-40% 0px -40% 0px' }); sio.observe(story); }
  }

  /* ---- pickers (accessible tabs) ---- */
  root.querySelectorAll('[data-ssh-picker]').forEach(function (pk) {
    var tabs = Array.prototype.slice.call(pk.querySelectorAll('.ssh-tab'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(n, true);
        }
      });
    });
  });
  /* quick-shop tiles jump straight to the right tab */
  root.querySelectorAll('[data-ssh-jump]').forEach(function (a) {
    a.addEventListener('click', function () {
      var t = document.getElementById('ssh-t-' + a.getAttribute('data-ssh-jump'));
      if (t) t.click();
    });
  });

  /* ---- free shipping meter (reads the real cart) ---- */
  var tEl = document.querySelector('[data-threshold]');
  var threshold = (tEl && parseInt(tEl.getAttribute('data-threshold'), 10)) || 7500;
  function paintShip(total) {
    var txt = document.getElementById('ssh-ship-text'), fill = document.getElementById('ssh-ship-fill');
    if (!txt || !fill) return;
    var pct = Math.min(100, Math.round(total / threshold * 100));
    fill.style.width = pct + '%';
    if (total <= 0) txt.innerHTML = 'Free shipping on orders over <b>' + fmt(threshold) + '</b>';
    else if (total < threshold) txt.innerHTML = 'You’re <b>' + fmt(threshold - total) + '</b> from free shipping';
    else txt.innerHTML = '<b>Free shipping</b> is on us. You’re set.';
  }
  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      paintShip(c.total_price || 0);
      document.querySelectorAll('.cart-link__count, .cart-count, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      return c;
    }).catch(function () {});
  }
  refreshCart();

  /* ---- quick add ---- */
  var toast = document.getElementById('ssh-toast'), tmsg = document.getElementById('ssh-toast-msg'), tt;
  function showToast(m) { if (!toast) return; tmsg.textContent = m; toast.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('is-on'); }, 4200); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ssh-add]');
    if (!b) return;
    e.preventDefault();
    var label = b.textContent; b.disabled = true; b.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-ssh-add'), 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function (c) {
        var left = threshold - ((c && c.total_price) || 0);
        showToast(b.getAttribute('data-ssh-title') + ' added' + (left > 0 ? ' · ' + fmt(left) + ' to free shipping' : ' · free shipping unlocked'));
        b.textContent = 'Added ✓';
        setTimeout(function () { b.textContent = label; b.disabled = false; }, 1800);
      })
      .catch(function () { b.textContent = label; b.disabled = false; showToast('Couldn’t add that one. Try the product page.'); });
  });

  /* ---- hero: a flight of ducks crossing the dawn ---- */
  var cv = document.getElementById('ssh-sky');
  if (cv && cv.getContext) {
    var ctx = cv.getContext('2d'), W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), flocks = [], t0 = performance.now(), raf;
    var size = function () { var r = cv.getBoundingClientRect(); W = r.width; H = r.height; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    var flock = function (delay) {
      var n = 5 + Math.floor(Math.random() * 5), s = 1.0 + Math.random() * 0.7, y = H * (0.4 + Math.random() * 0.24);
      var birds = []; for (var i = 0; i < n; i++) { var side = i % 2 ? 1 : -1, rank = Math.ceil(i / 2); birds.push({ dx: -rank * 26 * s, dy: side * rank * 13 * s, ph: Math.random() * 6.28 }); }
      return { x: -120 - delay, y: y, s: s, v: (28 + Math.random() * 22) * s, drift: (Math.random() - .5) * 6, birds: birds };
    };
    var bird = function (x, y, s, ph) {
      var w = Math.sin(ph) * 5 * s;
      ctx.beginPath(); ctx.moveTo(x - 11 * s, y - w); ctx.quadraticCurveTo(x - 5 * s, y - 3 * s - w * .4, x, y); ctx.quadraticCurveTo(x + 5 * s, y - 3 * s - w * .4, x + 11 * s, y - w); ctx.stroke();
    };
    var draw = function (now) {
      var dt = Math.min(0.05, (now - t0) / 1000); t0 = now;
      ctx.clearRect(0, 0, W, H); ctx.strokeStyle = 'rgba(11,17,13,.88)'; ctx.lineCap = 'round';
      flocks.forEach(function (f) {
        f.x += f.v * dt; f.y += f.drift * dt; ctx.lineWidth = 2.2 * f.s;
        f.birds.forEach(function (b) { b.ph += dt * 9; bird(f.x + b.dx, f.y + b.dy, f.s, b.ph); });
        if (f.x - 260 > W) { var nf = flock(Math.random() * 400); f.x = nf.x; f.y = nf.y; f.s = nf.s; f.v = nf.v; f.birds = nf.birds; f.drift = nf.drift; }
      });
      if (!reduce) raf = requestAnimationFrame(draw);
    };
    size(); flocks = [flock(0), flock(500)]; flocks[0].x = W * 0.35;
    window.addEventListener('resize', size);
    if (reduce) { draw(performance.now()); }
    else {
      var vis = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { t0 = performance.now(); cancelAnimationFrame(raf); raf = requestAnimationFrame(draw); } else { cancelAnimationFrame(raf); } });
      vis.observe(cv);
    }
  }

  /* warm hidden picker tabs after load so switching never shows an empty card */
  window.addEventListener('load', function () { setTimeout(function () {
    document.querySelectorAll('.ssh-panel[hidden] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }, 1500); });
})();
